import { render } from "./QrCodeBlock.vue?vue&type=template&id=0123f5fb"
import script from "./QrCodeBlock.vue?vue&type=script&lang=js"
export * from "./QrCodeBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__